import React,{useState, useEffect, useRef} from 'react';
import { Route, Switch, StaticRouter } from 'react-router-dom';
import Home from './Home';
import VideoPage from './pages/Video';
import ClipPage from './pages/Clip';
import ProfilePage from './pages/Profile';
import GroupPage from './pages/GroupPage';
import MatchSummary from './pages/MatchSummary';
import Scorecard from './pages/Scorecard';
import AwardPage from './pages/AwardPage';
import RemoteGlipPage from './pages/RemoteGlipPage';
import GlipListPage from './pages/GlipListPage';
import MemePage from './pages/MemePage';
import NFTListPage from './pages/NFTListPage';
import NFTDetailPage from './pages/NFTDetailPage';
import MarketHomePage from './pages/MarketHomePage';
import UserPage from './pages/UserPage';
import TwitchSuccessLogin from './pages/TwitchSuccessLogin';
import YoutubeSuccessLogin from './pages/YoutubeSuccessLogin';
import YoutubeChatBotManager from './pages/YoutubeChatBotManager';
import LoginSocketComponent from './components/utilityComponents/LoginSocketComponent';
import TwitchOverlay from './pages/TwitchOverlay';
import PerkOverlay from './pages/PerkOverlay';
import TwitchOverlayTest from './pages/TwitchOverlayTest';
import MarketSolo from './pages/MarketSolo';
import ClaimPerksPage from './pages/ClaimPerksPage';
import ClaimGlipBox from './pages/ClaimGlipBox';
import PrimeList from './pages/PrimeList';
import PrimeMint from './pages/PrimeMint';
import PrimeOpensea from './pages/PrimeOpensea';
import FlashTest from './pages/FlashTest';
import UserStore from './pages/UserStore';
import UserStoreItem from './pages/UserStoreItem';
import UsePower from './pages/UsePower';
import DemoLogin from './pages/DemoLogin';
import OverlayDisplay from './pages/Overlay/OverlayDisplay';
import Editor from './pages/Editor';
import Main from './pages/Overlay/Main';
import OverlayTriggerTest from './pages/OverlayTriggerTest';
import OverlayPowers from './pages/OverlayPowers';
import Otherside from './pages/Otherside';
import DownloadConnectWallet from './pages/DownloadConnectWallet';
import eventBus from './utils/globalPubSub';
import {loginUser, getLoginInformation} from './utils/loginHelper';
import {checkConnection} from './utils/chainUtils';
import './App.css';

import { UserContext } from './utils/userDetailsProvider';

import {fetchLocation} from './utils/backendUtils';

import Analytics from 'analytics';
import segmentPlugin from '@analytics/segment';
import {onMessageListener} from './firebaseClient';

var ua = navigator.userAgent.toLowerCase(); 
import { io } from 'socket.io-client';

import {PUBLIC_ADDRESS_TWITCH_CHECK, SOCKET_URL} from  './constants/urls'
import {NeoFrame} from "@/components/frames";
import ReactGA from 'react-ga4';
import L2EDownloadPage from './pages/L2EDownloadPage';
import CreatorGameDownload from './pages/CreatorGameDownload';


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

const App = () => {
    // const forceUpdate = useForceUpdate();
    // const [s, setSocket] = useState();
    const userDetails = useRef({});

    // const setUserDetails = (newVal)=>{
    //     userDetails.current = newVal;
    //     forceUpdate();
    // }
    
    // const socketInformation = useRef({});

    
    // const [width, setWidth] = useState<number>(window.innerWidth);
    
    // function handleWindowSizeChange() {
    //     setWidth(window.innerWidth);
    //     if(window.innerWidth <= 768){
    //         console.log('deviceType', window.innerWidth)
    //         setUserDetails({...userDetails.current, isMobile:true})
    //     }
    //     else{
    //         setUserDetails({...userDetails.current, isMobile:false})
    //     }
    // }
    
    // useEffect(() => {
    //     window.addEventListener('resize', handleWindowSizeChange);
    //     handleWindowSizeChange()
    //     return () => {
    //         window.removeEventListener('resize', handleWindowSizeChange);
    //     }
    // }, []);

    // const isMobile = width <= 768;

    
    useEffect(() => {
        if(window.androidEmbeded) {
            window.subscribeBackPress();
        };
    });
    
    // const analytics = Analytics({
    //     app: 'glip-web-app',
    //     plugins: [
    //         segmentPlugin({
    //             writeKey: 'dGhqEJo2XXuL8316y1wF0XpZxSRyqSyz'
    //         })
    //     ]
    // });
    // window.analytics = analytics;
    // analytics.page();
    
    var url = new URL(window.location.href);
    var _branch_match_id = url.searchParams.get("_branch_match_id");
    var _branch_referrer = url.searchParams.get("_branch_referrer");
    // console.log(_branch_match_id, _branch_referrer)

    // window.analytics.track('_branch_referrer', {
    //     value: _branch_referrer,
    // });

    // window.analytics.track('_branch_match_id', {
    //     value: _branch_match_id,
    // })
    

    // useEffect(()=>{
    //     eventBus.on("twitch-details-found",(data)=>{
    //         loginUser(data);
    //     });
    //     return ()=>{
    //         eventBus.remove("twitch-details-found");
    //     }
    // },[]);

    // useEffect(() => {
    //     ReactGA.initialize('G-468QW4MH4N');
    // }, []);
        
    // useEffect(()=>{
    //     (async ()=>{
    //         let data = await fetchLocation();
    //         if(url.searchParams.get('not_india')){
    //             setUserDetails({
    //                 ...userDetails.current,
    //                 ipLocationCountryCode:'BULL'
    //             })
    //             return;
    //         }
    //         setUserDetails({
    //             ...userDetails.current,
    //             ipLocationCountryCode:data.country_code
    //         })
    //         console.log('fetch location', data);
    //     })();
    // },[]);

    
    // const checkSetTwitchDetails = async(publicAddress)=>{
    //     localStorage.setItem('twitch-details-found', JSON.stringify(
    //         false));
    //     let fetchUrl = PUBLIC_ADDRESS_TWITCH_CHECK + `?publicKey=${publicAddress}`;
    //     let response = await fetch(fetchUrl);
    //     response = await response.json();
    //     if(!response.success){
    //         return;
    //     }
    //     localStorage.setItem(
    //         'twitch-details-found', JSON.stringify(true));
    // }
    
    // if (ua.indexOf('safari') != -1) { 
    //     if (ua.indexOf('chrome') > -1) {
    //         onMessageListener().then(payload => {
    //             console.log('notif payload', payload);
    //         }).catch(err => console.log('failed: ', err));
    //     }
    // }
    
    // const connectSocket = (userId, userName) => {
    //     const socket = io(SOCKET_URL, {
    //         transports: ['websocket'], query: {roomId:`u-${userId}`}});
    //     socketInformation.current.userId = userId;
    //     socketInformation.current.socket = socket;
    //     socket.on('connect', () => {
    //         socket.on('message', (data: any) => {
    //             console.log('data', data);
    //             if(data.type === "onBidWin"){
    //                 eventBus.dispatch("auction-won", {userName});
    //             }
    //         });
    //         socket.on('data', (data) => {
    //         });
    //     });
        
    //     socket.on('disconnect', (reason) => {
    //         console.log(socket.id, reason);
    //         console.log('disconnect gg')
    //         socketInformation.current.socket = undefined;
    //         socketInformation.current.userId = undefined;
    //     });
    // }
    
    // useEffect(() => {
    //     let userInformation = getLoginInformation();
    //     if(userInformation){
    //         connectSocket(userInformation.user._id,
    //                       userInformation.user.username)
    //     }
    //     eventBus.on("user-logged-in", (userData) => {
    //         let userId = userData.user.id;
    //         if(!socketInformation){
    //             return
    //         }
    //         if((socketInformation.current.userId ===  userId) && socketInformation.current.socket!=undefined){
    //             return;
    //         }
    //         if(socketInformation.current.userId !==  userId && socketInformation.current.socket != undefined){
    //             socketInformation.current.userId= undefined;
    //             socketInformation.current.socket.disconnect();
    //             socketInformation.current.socket= undefined;
    //         }
    //         if(!userId){return;}
    //         connectSocket(userId, userData.user.username);
    //     });
    //     eventBus.on("user-logged-out", (user) => {
    //         socketInformation.current.userId= undefined;
    //         if(socketInformation.current.socket){
    //             socketInformation.current.socket.disconnect();
    //             socketInformation.current.socket= undefined;
    //         }
    //     })
    //     return () => {
    //         eventBus.remove("public-address-found");
    //         if (socketInformation.current.socket) {
    //             socketInformation.current.socket.disconnect();
    //             socketInformation.current.socket = undefined;
    //             socketInformation.current.userId = undefined;
    //         }            
    //     };
    // },[]);

    return(
	<>
            <UserContext.Provider value={userDetails.current}>
	        {/* <LoginSocketComponent/> */}
	        <Switch>
                    
                    <Route exact path="/twitch-success-login" component={TwitchSuccessLogin} />
                    <Route exact path="/youtube-success-login" component={YoutubeSuccessLogin} />
                    <Route exact path="/watch/:videoId" component={VideoPage} />
                    <Route exact path="/clip/:videoId" component={ClipPage} />
                    <Route exact path="/profile/:profileId" component={ProfilePage} />
                    <Route exact path="/profile/" component={UserPage} />
                    <Route exact path="/groups/:groupId" component={GroupPage} />
                    <Route exact path="/match/:matchId" component={MatchSummary} />
                    <Route exact path="/scorecard/:matchId" component={Scorecard} />
                    <Route exact path="/award/" component={AwardPage} />
                    <Route exact path="/ge/" component={RemoteGlipPage} />
                    <Route exact path="/glip-list/:matchId/:groupId/" component={GlipListPage} />
                    <Route exact path="/group/:groupId/match/:matchId/" component={GlipListPage} />
                    <Route exact path="/group/:groupId/match/:matchId/clip/:videoId" component={ClipPage} />
                    <Route exact path="/meme/" component={MemePage} />
                    <Route exact path="/address/:address/" component={UserPage} />
                    <Route exact path="/perks/claim/" component={ClaimPerksPage} />
                    <Route exact path="/store/:username" component={UserStore} />
                    <Route exact path="/store/:username/:item" component={UserStoreItem} />
                    <Route exact path="/power/:powerId" component={UsePower} />
                    <Route exact path="/u/:username" component={NFTListPage} />
                    <Route exact path="/u/:username/:videoId" component={NFTDetailPage} />
                    <Route exact path="/market/" component={MarketHomePage} />
                    <Route exact path="/market/solo" component={MarketSolo} />
                    <Route exact path="/twitch-overlay/:username" component={TwitchOverlay} />
                    <Route exact path="/perk-overlay/:username" component={PerkOverlay} />
                    <Route exact path="/twitch-overlay-test/" component={TwitchOverlayTest} />
                    <Route exact path="/claim/glipbox/:username" component={ClaimGlipBox} />
                    <Route exact path="/primevp/list" component={PrimeList} />
                    <Route exact path="/primevp/mint/:company" component={PrimeMint} />
                    <Route exact path="/primevp/137/:contractAddress/:tokenId/" component={PrimeOpensea} />
                    <Route exact path="/flash-test" component={FlashTest} />
                    <Route exact path="/overlay-powers/:username" component={OverlayPowers} />
                    <Route exact path="/demo-login" component={DemoLogin} />
                    <Route path="/widget-setup" component={Main}/>
                    <Route exact path="/overlay/" component={OverlayDisplay}/>
                    <Route exact path="/overlay/:userId" component={OverlayDisplay}/>
                    <Route path="/editor/" component={Editor}/>
                    <Route path="/overlay-test/" component={OverlayTriggerTest}/>
                    <Route path="/otherside/" component={Otherside}/>
                    <Route path="/l2e/:userID/:game/" component={L2EDownloadPage}/>
                    <Route path="/youtube-chat-bot-manager/"
                           component={YoutubeChatBotManager}/>
                    <Route exact path="/cd/:creator_image/:banner_image/:creator_name" component={CreatorGameDownload} />
                    <Route exact path="/" component={Home} />
                    <Route exact path="/openDeeplink" component={DownloadConnectWallet} />
	        </Switch>
            </UserContext.Provider>
	</>
)};

export default App;

//openDeeplink?deeplink=glipwallet://open_url